export default __webpack_public_path__ + "static/media/Parallax-HUD-Dock Icons.e6965770.jpg";